// this helped
// https://stackoverflow.com/questions/18333936/how-to-drag-images-objects-within-canvas?rq=1


export function imageDrag( image, canv, savedRot ) {
    let isDraggable = false,
        img = image,
        images = [img],
        dragging = [],
        imgHeight = image.height,
        imgWidth = image.width,
        lastX = canv.width / 2 - img.width / 2,
        lastY = canv.height / 2 - img.height / 2,
        panX = canv.width / 2 - img.width / 2,
        panY = canv.height / 2 - img.height / 2,
        mouseX = 0,
        mouseY = 0,
        lastZoom = 1,
        rotationAng = 0;

    let offsetX = canv.offsetLeft;
    let offsetY = canv.offsetTop;

    function drawImage( isRotate ) {
        let dd = canv.getContext( '2d' )
        dd.fillStyle = "black";
        //dd.fillRect( 0, 0, canv.width, canv.height );
        dd.fillRect(-1000,-1000,2000,2000 ); 
        const z = lastZoom;
        let effX = panX,
            effY = panY;
        const w = canv.width / 2,
            h = canv.height / 2,
            rot = rotationAng / 180 * Math.PI;      
        if ( isRotate ) {
            lastX = canv.height / 2;
            lastY = canv.width / 2;
            mouseX = canv.height / 2 - ( img.height * z ) / 2;
            mouseY = canv.width / 2 - ( img.width * z ) / 2;
            offsetX = 0;
            offsetY = 0;
            panY = canv.height / 2 - ( img.height * z ) / 2;
            panX = canv.width / 2 - ( img.width * z ) / 2;
            effX = canv.width / 2 - ( img.width * z ) / 2;
            effY = canv.height / 2 - ( img.height * z ) / 2;
        };
        dd.save();
        dd.translate( w, h )
        dd.rotate( rot );
        dd.translate( -w, -h );
        dd.drawImage( img, effX, effY, img.width*z, img.height*z);
        dd.restore();
    }

    function imagesHitTests( x, y ) {
        let hits = [];
        hits.push( 1 );
        return ( hits );
    }

    return {
        handleMouseUp: function( e ) {
            dragging = [];
        },

        handleMouseOut: function( e ) {
            dragging = [];
        },

        handleMouseMove: function( e ) {
            const totRot = (savedRot + rotationAng) % 360;
            if ( dragging && dragging.length > 0 ) {
                mouseX = parseInt( e.clientX - offsetX );
                mouseY = parseInt( e.clientY - offsetY );     
                let dx = mouseX - lastX;
                let dy = mouseY - lastY;
                if ( totRot === 90 ) {
                    dx = mouseY - lastY;
                    dy = lastX - mouseX;
                } else if ( totRot === 180 ) {
                    dx = lastX - mouseX ;
                    dy = lastY - mouseY ;
                } else if ( totRot === 270 ) {
                    dx = lastY - mouseY ;
                    dy = mouseX - lastX ;
                } 
                lastX = mouseX;
                lastY = mouseY;
                if ( dx < canv.width - ( img.width / 2 ) && dy < canv.height - ( img.height / 2 ) ) {
                  panX += dx;
                  panY += dy;
                }
                drawImage();
            }
        },
        mouseDown: function( e ) {
            mouseX = parseInt( e.clientX - offsetX );
            mouseY = parseInt( e.clientY - offsetY );
            lastX = mouseX;
            lastY = mouseY;
            dragging = imagesHitTests( mouseX, mouseY )
        },
        scaleImage: function( zoomFactor ) {
            lastZoom = zoomFactor;
            drawImage();

        },
        rotateImage: function( rotation ) {
            rotationAng = ( rotation % 4 ) * 90;
            drawImage( true );

        }

    }
}
